module.exports = __webpack_public_path__ + "img/Vangsgutane_Odd_Ekre_Nigard.328874f8.jpg";